<p-toast></p-toast>
<p-table [value]="data" [rowHover]="true" dataKey="id">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name" scope="col">Nombre <p-sortIcon field="name"></p-sortIcon></th>
      <th scope="col">Logo</th>
      <th scope="col">Color</th>
      <th scope="col">Teléfono</th>
      <th scope="col">Link de privacidad</th>
      <th scope="col" style="width: 5rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <tr>
      <td>
        {{ data.name }}
      </td>
      <td>
        <p-image [src]="data.image" alt="Logo" width="70" [preview]="true" />
      </td>
      <td>
        <div
          [style.background]="data.color"
          style="width: 2rem; height: 2rem; border-radius: 4px"
        ></div>
      </td>
      <td>
        {{ data.phone }}
      </td>
      <td>
        <a [href]="data.privacyLink" target="_blank">Ver políticas de privacidad</a>
      </td>
      <td>
        <div class="flex gap-2 flex-column md:flex-row">
          <button
            pButton
            pRipple
            icon="pi pi-file-edit"
            class="p-button-rounded p-button"
            (click)="openModalEdit(data)"
          ></button>
          @if(appName !== "Caser MIMAvet") {
          <button
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-rounded p-button mr-2 p-button-danger"
            (click)="onDelete(data)"
          ></button>
          }
          <p-button
            label="Especialistas"
            icon="pi pi-users"
            (click)="viewSpecialists(data)"
            onKeyPress=""
          />
          <p-button label="Usuarios" icon="pi pi-users" (click)="viewUsers(data)" onKeyPress="" />
          <p-button
            label="Visitas"
            icon="pi pi-calendar"
            (click)="viewVisits(data)"
            onKeyPress=""
          />
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog
  header="Vas a borrar una clínica"
  key="onDelete"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '350px' }"
  severity="danger"
  acceptButtonStyleClass="p-button-text"
  rejectButtonStyleClass="p-button-text"
></p-confirmDialog>

<p-dialog
  header="Editar Clínica"
  [modal]="true"
  [(visible)]="editModal"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '30vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="content">
    <form class="p-fluid py-2" [formGroup]="form">
      <div class="field">
        <p-fileUpload
          accept="image/png, image/jpeg"
          chooseLabel="Seleccionar imagen"
          chooseIcon="pi pi-upload"
          [customUpload]="true"
          [maxFileSize]="5000000"
          (uploadHandler)="onUpload($event)"
          [auto]="true"
        >
          <ng-template pTemplate="file">
            @if(selectedFile && previewUrl) {
            <p-image
              [src]="previewUrl"
              alt="Image"
              width="150"
              styleClass="flex justify-content-center"
            />

            }
          </ng-template>
        </p-fileUpload>
        @if(clinic.image && !previewUrl) {
        <p-image
          [src]="clinic.image"
          alt="Image"
          width="150"
          styleClass="flex justify-content-center mt-5"
        />
        } @if (this.form.controls["fileImage"].touched && this.form.controls["fileImage"].dirty &&
        this.form.controls["fileImage"].invalid) {
        <small class="p-error">Imagen inválida</small>
        }
      </div>
      <div class="field">
        <label class="block" for="color">Color</label>
        <p-colorPicker formControlName="color" id="color" />
      </div>
      <div class="field">
        <span class="p-float-label">
          <input id="name" type="text" pInputText formControlName="name" />
          <label for="name">Nombre</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.controls['name'].touched &&
            form.controls['name'].dirty &&
            form.controls['name'].invalid
          "
          >Campo requerido</small
        >
      </div>

      <div class="field">
        <span class="block mb-1">Teléfono</span>
        <ngx-intl-tel-input
          [cssClass]="'p-inputtext p-component p-element min-w-full'"
          [onlyCountries]="onlyCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="false"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.Spain"
          [maxLength]="15"
          [phoneValidation]="true"
          [separateDialCode]="true"
          [numberFormat]="PhoneNumberFormat.National"
          name="phone"
          formControlName="phone"
          id="phoneNumber"
        >
        </ngx-intl-tel-input>

        <small
          class="p-error block"
          *ngIf="
            form.controls['phone'].touched &&
            form.controls['phone'].dirty &&
            form.controls['phone'].invalid
          "
        >
          Ingresa un número de teléfono válido
        </small>
      </div>

      <div class="field">
        <span class="p-float-label">
          <input id="privacyLink" type="text" pInputText formControlName="privacyLink" />
          <label for="privacyLink">Link de privacidad</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.controls['privacyLink'].touched &&
            form.controls['privacyLink'].dirty &&
            form.controls['privacyLink'].invalid
          "
          >Campo requerido</small
        >
      </div>

      <h5 class="text-center mb-0">Código de la clínica</h5>
      <div class="flex justify-content-center">
        <qrcode
          [qrdata]="clinic.id"
          [width]="256"
          [errorCorrectionLevel]="'M'"
          [margin]="1"
        ></qrcode>
      </div>
      <h6 class="text-center m-0">{{ clinic.id }}</h6>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      [loading]="loading"
      icon="pi pi-check"
      label="Guardar"
      onKeyPress=""
      (click)="save()"
    />
  </ng-template>
</p-dialog>
